import type { TypographyProps } from './Typography';
import { Typography } from './Typography';

export type TextButtonProps = Pick<
  TypographyProps,
  'label' | 'color' | 'ellipsis'
>;

export const TextButton = ({
  ellipsis,
  label,
  color = 'text-ds-natural',
}: TextButtonProps) => (
  <Typography
    ellipsis={ellipsis}
    color={color}
    label={label}
    tagName="span"
    fontSize="text-ds-400"
    lineHeight="leading-ds-300"
    fontWeight="font-ds-medium"
  />
);
